import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AdminLayout from '../../components/layout/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `${(v ?? 0).toFixed(2)} €`;

const Big = ({ label, value, sub, accent }) => (
  <Card className="border-border"><CardContent className="py-4">
    <p className="text-xs text-muted-foreground">{label}</p>
    <p className={`text-2xl font-bold ${accent || ''}`}>{value}</p>
    {sub && <p className="text-xs text-muted-foreground mt-0.5">{sub}</p>}
  </CardContent></Card>
);

const TopList = ({ title, rows, render }) => (
  <Card className="border-border">
    <CardHeader className="pb-2"><CardTitle className="text-sm">{title}</CardTitle></CardHeader>
    <CardContent className="pt-0 space-y-1.5">
      {rows.length === 0 && <p className="text-xs text-muted-foreground">—</p>}
      {rows.map(render)}
    </CardContent>
  </Card>
);

export default function AdminExecutive() {
  const [d, setD] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/analytics/executive`)
      .then((r) => setD(r.data))
      .catch(() => toast.error('Erreur de chargement'));
  }, []);

  if (!d) return <AdminLayout title="Direction"><div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div></AdminLayout>;

  return (
    <AdminLayout title="Tableau de bord dirigeant" subtitle="Vue quotidienne du négoce">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-5" data-testid="executive-kpis">
        <Big label="Commandes aujourd'hui" value={d.today.orders} />
        <Big label="CA aujourd'hui" value={eur(d.today.revenue)} />
        <Big label="Marge aujourd'hui" value={eur(d.today.margin)} accent="text-green-600" />
        <Big label="Marge du mois" value={eur(d.month.margin)} sub={`CA ${eur(d.month.revenue)} · ${d.month.orders} cmd`} accent="text-green-600" />
        <Big label="Marge de l'année" value={eur(d.year.margin)} sub={`CA ${eur(d.year.revenue)} · ${d.year.orders} cmd`} accent="text-green-700" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
        <Big label="🔴 Dossiers bloqués" value={d.blocked} accent={d.blocked > 0 ? 'text-red-600' : ''} />
        <Big label="🏭 Laboratoires actifs" value={d.active_labs} />
        <Big label="⏰ Commandes en retard" value={d.late_count} accent={d.late_count > 0 ? 'text-orange-600' : ''} />
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <TopList title="🏆 Meilleurs clients" rows={d.top_clients} render={(c) => (
          <div key={c.key} className="flex justify-between text-xs">
            <span className="truncate">{c.key}</span><span className="font-semibold">{eur(c.revenue)}</span>
          </div>)} />
        <TopList title="🦷 Meilleurs produits" rows={d.top_products} render={(p) => (
          <div key={p.key} className="flex justify-between text-xs">
            <span className="truncate">{p.key}</span><span className="font-semibold">{p.count} cmd</span>
          </div>)} />
        <TopList title="⏰ Retards" rows={d.late} render={(o) => (
          <Link key={o.id} to={`/admin/orders/${o.id}`} className="flex justify-between text-xs hover:underline">
            <span className="font-mono">{o.order_number}</span>
            <span className="text-muted-foreground">{o.fabricant_deadline}</span>
          </Link>)} />
      </div>
    </AdminLayout>
  );
}
